<template>
  <div>
    <Head @langChange="langSelect" />
    <section
      class="gameTop TopWarp"
      :style="{
        'background-color': '' + TopBgColor + '',
      }"
    >
      <img :src="TopUrl" alt="" />
      <div class="cont">
        <p class="p1" v-if="TopTitle != ''">{{ TopTitle }}</p>
        <p v-if="TopContent != ''">{{ TopContent }}</p>
      </div>
    </section>
    <section class="newsWarp cl">
      <div class="title">{{ title }}</div>
      <div class="date">{{ publish_time }}</div>
      <div class="content" v-html="content"></div>
    </section>
    <!-- 底部footer -->
    <Foot ref="foot"></Foot>
  </div>
</template>

<script>
import Head from "@/components/head.vue";
import Foot from "@/components/Foot.vue";
import { getNewsDetail } from "@/common/api.js";

export default {
  name: "newsDetail",
  metaInfo() {
    return {
      title: this.title,
    };
  },
  components: {
    Head,
    Foot,
    getNewsDetail,
  },
  data() {
    return {
      TopUrl: "",
      TopBgColor: "",
      TopTitle: "",
      TopContent: "",
      title: "",
      publish_time: "",
      content: "",
      lang: this.$route.query.language || "zh",
    };
  },
  beforeMount() {
    // 在页面挂载前就发起请求
    this.getDetail();
  },
  methods: {
    getDetail() {
      let that = this;
      getNewsDetail({
        id: that.$route.query.id,
        language: that.lang,
      }).then((res) => {
        if (res.status == 200) {
          let Data = res.data.data;
          that.TopUrl = Data.TopUrl;
          that.TopBgColor = Data.TopBgColor;
          that.title = Data.title;
          that.publish_time = Data.publish_time;
          that.content = Data.content;
        } else {
          console.log(res.statusText);
        }
      });
    },
    langSelect: function (param) {
      this.lang = param;
      this.getDetail();
      this.$refs.foot.langSelect(param);
    },
    //跳转详情
    Detail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: { id: id, language: this.lang },
      });
    },
  },
  computed: {
    // ...mapState({
    //   lang: (state) => state.lang,
    // }),
  },
};
</script>

<style scoped>
</style>





















































// WEBPACK FOOTER //
// src/views/newsDetail.vue